import React from 'react'

export interface StatsProps {
    data?:any
    value?:any
    bgColor?:any
}
export function Stats(props:StatsProps) {
    console.log("print the color value",props.bgColor)
    return (

       
        // <div className="bg-red-300 w-32 h-24 h- lg:w-44 lg:h-36 drop-shadow-xl space-y-4 flex flex-col rounded-xl items-center justify-center">
        // <div className={`bg-${props?.bgColor} w-44 h-36 drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}> 
        // <div className={`bg-${props?.bgColor} xl:w-48 xl:h-40 lg:w-44 lg:h-36 drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}>


         <div className={`bg-${props?.bgColor} 2xl:w-56 2xl:h-44 xl:w-48 xl:h-36 drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}>
          {/* <div className={`bg-mk-pink 2xl:w-56 2xl:h-44 xl:w-48 xl:h-36 drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}>  */}
         {/* <div className={`bg-mk-blue 2xl:w-56 2xl:h-44 xl:w-48 xl:h-36 drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}>  */}



        {/* <div className={`bg-${props?.bgColor} w-[80%] h-[60%] drop-shadow-xl rounded-3xl flex flex-col items-center justify-center`}> */}
            <div className="2xl:text-6xl xl:text-5xl md:text-4xl font-bold text-center mb-2">{props.data!!}</div>
            <div className="2xl:text-lg xl:text-base font-bold text-center mt-2">{props.value!!}</div>
        </div>
    )
}
// ${props?.bgColor}